// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy__footer[data-v-0d353242]{margin-top:60px}.privacy__last-updated[data-v-0d353242]{font-style:italic}", ""]);
// Exports
module.exports = exports;
